(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["onekind-routine-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('onekind-routine-hero')) {
    customElements.define('onekind-routine-hero', class extends HTMLElement {
      connectedCallback() {
        this._start = () => this.initialize();
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this._start, { once: true });
        else this.initialize();
      }
      initialize() {
        if (this._active || !this.isConnected) return;
        this._active = true;
        this._wrapper = this.closest('.shopify-section');
        this._skipEntrance = this._wrapper?.dataset.okrSkipEntrance === 'true';
        this._seen = new WeakSet();
        this._animations = new Set();
        this._pending = new Map();
        this._motion = matchMedia('(prefers-reduced-motion: reduce)');
        this._measure = () => {
          // Document position includes the actual announcement bar and store header.
          const before = Math.max(0, this.getBoundingClientRect().top + window.scrollY);
          this.style.setProperty('--okr-before', before + 'px');
        };
        this._measure();
        this._resize = new ResizeObserver(this._measure);
        const main = this.closest('#main, main, [role="main"]');
        // Watch header changes without resizing in response to our own content.
        document.querySelectorAll('.shopify-section-group-header-group, [id$="__header"], [id$="__announcement-bar"]').forEach(node => this._resize.observe(node));
        window.addEventListener('resize', this._measure);
        this._observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.01) return;
            this.reveal(entry.target);
            this._observer.unobserve(entry.target);
          });
        }, { threshold: 0.01, rootMargin: '0px 0px -48px 0px' });
        this._scan = () => {
          if (!main) return;
          let afterHero = false;
          Array.from(main.children).forEach(section => {
            if (section.contains(this)) { afterHero = true; return; }
            if (afterHero && section.classList.contains('shopify-section') && !this._seen.has(section)) {
              this.prepare(section);
              this._observer.observe(section);
            }
          });
        };
        this._focus = event => {
          this._skipEntrance = true;
          const section = event.target.closest?.('.shopify-section');
          if (section) { this._seen.add(section); this._observer.unobserve(section); }
          // Never make focused controls wait for an entrance effect.
          this._animations.forEach(animation => animation.cancel());
          this._pending.forEach((animation, node) => this._seen.add(node));
          this._pending.clear();
        };
        this._reduce = () => {
          if (!this._motion.matches) return;
          this._animations.forEach(animation => animation.cancel());
          this._pending.forEach((animation, node) => this._seen.add(node));
          this._pending.clear();
        };
        this._motion.addEventListener('change', this._reduce);
        main?.addEventListener('focusin', this._focus);
        this._main = main;
        document.addEventListener('shopify:section:load', this._scan);
        this._scan();
        this.reveal(this.querySelector('.okr-hero__inner'), { duration: 3000 });
        this.reveal(this.querySelector('.okr-hero__tip'), { duration: 2200, delay: 1500 });
        // The animations now own the hidden starting state; remove the prepaint guard.
        this._wrapper?._okrReleasePrepaint?.();
      }
      prepare(node, options = {}) {
        if (!node || this._seen.has(node) || this._pending.has(node)) return;
        // Only working JS animations hide content; cancellation restores visibility.
        if (this._skipEntrance || this._motion.matches || !node.animate) return;
        const animation = node.animate([
          { opacity: 0, transform: 'translateY(12px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 2600, easing: 'cubic-bezier(.25,.1,.25,1)', fill: 'backwards', ...options });
        animation.pause();
        animation.currentTime = 0;
        this._pending.set(node, animation);
        this._animations.add(animation);
        animation.finished.catch(() => {}).finally(() => this._animations.delete(animation));
      }
      reveal(node, options = {}) {
        if (!node || this._seen.has(node)) return;
        this.prepare(node, options);
        this._seen.add(node);
        const animation = this._pending.get(node);
        this._pending.delete(node);
        animation?.play();
      }
      disconnectedCallback() {
        this._wrapper?._okrReleasePrepaint?.();
        document.removeEventListener('DOMContentLoaded', this._start);
        if (!this._active) return;
        this._observer.disconnect();
        this._resize.disconnect();
        this._animations.forEach(animation => animation.cancel());
        window.removeEventListener('resize', this._measure);
        document.removeEventListener('shopify:section:load', this._scan);
        this._main?.removeEventListener('focusin', this._focus);
        this._motion.removeEventListener('change', this._reduce);
        this._active = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onekind-routine-savings"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('onekind-routine-savings')) {
    customElements.define('onekind-routine-savings', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          this._ready = () => this.initialize();
          document.addEventListener('DOMContentLoaded', this._ready, { once: true });
        } else this.initialize();
      }
      initialize() {
        if (this._initialized || !this.isConnected) return;
        this._initialized = true;
        this._revision = (this._revision || 0) + 1;
        this._animations = new Set();
        this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.steps = Array.from(this.querySelectorAll('[data-routine-step]'));
        this.stage = this.querySelector('[data-stage]');
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.setupSticky();
        this._onCart = event => {
          if (Array.isArray(event.detail?.cart?.items)) {
            ++this._revision;
            this.render(event.detail.cart, true);
          } else this.readCart(true);
        };
        this._resume = () => { if (!document.hidden) this.readCart(true); };
        this._layoutChange = () => this.cancelAnimations();
        this._retry = event => { if (event.target.closest('[data-retry]')) this.readCart(false); };
        this._editorChange = () => {
          if (this._cart) this.render(this._cart, false);
        };
        document.documentElement.addEventListener('cart:updated', this._onCart);
        document.documentElement.addEventListener('cart:refresh', this._onCart);
        document.addEventListener('shopify:section:load', this._editorChange);
        document.addEventListener('shopify:section:unload', this._editorChange);
        document.addEventListener('visibilitychange', this._resume);
        window.addEventListener('focus', this._resume);
        window.addEventListener('pageshow', this._resume);
        window.addEventListener('resize', this._layoutChange);
        this._motion.addEventListener?.('change', this._layoutChange);
        this.addEventListener('click', this._retry);
        try { this.render(this._cart || JSON.parse(this.querySelector('[data-initial-cart]').textContent), false); }
        catch (error) { this.render({ items: [] }, false); }
        this.readCart(false);
      }
      async readCart(animate = true) {
        const revision = ++this._revision;
        try {
          const response = await fetch(this.dataset.cartUrl + '.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
          if (!response.ok) throw new Error('Cart unavailable');
          const cart = await response.json();
          if (!this._initialized || !this.isConnected || revision !== this._revision) return;
          if (!Array.isArray(cart.items)) throw new Error('Invalid cart');
          this.render(cart, animate);
        } catch (error) {
          if (this._initialized && revision === this._revision) {
            this.querySelector('[data-cart-error]').hidden = false;
            this.querySelector('[data-announcement]').textContent = 'We could not refresh your cart. Try again or view your cart.';
          }
        }
      }
      setupSticky() {
        const template = this.querySelector('[data-sticky-template]');
        if (!template) return;
        this._sticky = template.content.firstElementChild.cloneNode(true);
        // Outside the animated section so transforms cannot trap fixed positioning.
        document.body.appendChild(this._sticky);
        this._stickyNotification = event => {
          if (event.detail?.status !== 'success') return;
          this.updateSticky();
          if (this._sticky.hidden || !this._sticky.getClientRects().length) return;
          // Suppress only the theme's success banner, never add/cart events or errors.
          event.preventDefault();
          event.stopImmediatePropagation();
        };
        window.addEventListener('cart-notification:show', this._stickyNotification, true);
        this._stickyHeaders = Array.from(document.querySelectorAll('.shopify-section-group-header-group'));
        this._stickyMain = this.closest('#main, main, [role="main"]');
        this._stickySchedule = () => {
          if (this._stickyFrame) return;
          this._stickyFrame = requestAnimationFrame(() => { this._stickyFrame = 0; this.updateSticky(); });
        };
        window.addEventListener('scroll', this._stickySchedule, { passive: true });
        window.addEventListener('resize', this._stickySchedule);
        document.addEventListener('transitionend', this._stickySchedule);
        document.addEventListener('focusin', this._stickySchedule);
        this._stickyResize = new ResizeObserver(this._stickySchedule);
        [this, ...this._stickyHeaders, this._stickyMain].filter(Boolean).forEach(node => this._stickyResize.observe(node));
        this._stickyOverlay = new MutationObserver(this._stickySchedule);
        this._stickyOverlay.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
        this._stickySchedule();
      }
      updateSticky() {
        if (!this._sticky || !this.isConnected) return;
        let top = 0;
        this._stickyHeaders.forEach(node => {
          const css = getComputedStyle(node), rect = node.getBoundingClientRect();
          if (['sticky', 'fixed'].includes(css.position) && css.visibility !== 'hidden' && rect.height && rect.bottom > 0 && rect.top <= top + 2) top = Math.max(top, rect.bottom);
        });
        this._sticky.style.setProperty('--okb-sticky-top', Math.round(top) + 'px');
        const originalBottom = Math.max(this.stage.getBoundingClientRect().bottom, this.querySelector('[data-progress-copy]').getBoundingClientRect().bottom);
        const overlayOpen = document.querySelector('cart-drawer[open], drawer-content[open], [role="dialog"][open], dialog[open]');
        const past = originalBottom <= top;
        const beforeFooter = !this._stickyMain || this._stickyMain.getBoundingClientRect().bottom > top + 100;
        const focused = document.activeElement;
        const focusRect = focused && focused !== document.body && !this._sticky.contains(focused) && this._stickyMain?.contains(focused) ? focused.getBoundingClientRect() : null;
        const barHeight = this._sticky.getBoundingClientRect().height || this._stickyHeight || 0;
        this._stickyHeight = barHeight;
        const obscuresFocus = focusRect && focusRect.top < top + barHeight && focusRect.bottom > top;
        const visible = ((past && beforeFooter) || this._sticky.contains(focused)) && !overlayOpen && !obscuresFocus;
        const wasHidden = this._sticky.hidden;
        this._sticky.hidden = !visible;
        if (!visible && this._stickyGhost) this.cancelAnimations();
        if (visible && wasHidden && !this._motion.matches) this.play(this._sticky, [{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 550 });
      }
      productIdsFor(step) {
        let ids = [];
        try { ids = JSON.parse(step.querySelector('[data-product-map]').textContent).map(String); } catch (error) {}
        const guide = document.querySelector('onekind-routine-steps');
        const guideStep = guide?.querySelectorAll('[data-step]')[Number(step.dataset.guidePosition) - 1];
        const panelId = guideStep?.getAttribute('aria-controls');
        const panel = panelId ? document.getElementById(panelId) : null;
        if (panel) panel.querySelectorAll('[data-product-id]').forEach(product => ids.push(product.dataset.productId));
        return new Set(ids);
      }
      render(cart, animate) {
        const items = cart.items.filter(item => Number.isFinite(Number(item.quantity)) && Number(item.quantity) > 0);
        const count = items.reduce((sum, item) => sum + Number(item.quantity), 0);
        const unlocked = count >= 3;
        const previousCount = this._count;
        const wasUnlocked = previousCount >= 3;
        const changed = count !== previousCount;
        const stickyStart = animate && previousCount !== undefined && !wasUnlocked && unlocked && this._sticky && !this._sticky.hidden && !this._motion.matches ? this.captureSticky() : null;
        this._cart = cart;
        this._count = count;
        this.querySelector('[data-cart-error]').hidden = true;
        this.querySelector('[data-count]').textContent = count + (count === 1 ? ' item in your cart' : ' items in your cart');
        this.querySelector('[data-view-cart]').hidden = count === 0;
        this.stage.classList.toggle('is-unlocked', unlocked);
        const progress = this.querySelector('[data-progress-copy]');
        progress.style.visibility = unlocked ? 'hidden' : 'visible';
        progress.setAttribute('aria-hidden', String(unlocked));
        const remaining = Math.max(0, 3 - count);
        const progressTemplate = remaining === 1 ? progress.dataset.progressSingular : progress.dataset.progressPlural;
        progress.textContent = (progressTemplate || '').split('{remaining}').join(String(remaining));
        if (this._sticky) {
          this._sticky.classList.toggle('is-unlocked', unlocked);
          this._sticky.querySelectorAll('.okb-sticky__dots > .okb-sticky__dot').forEach((dot, index) => dot.classList.toggle('is-filled', count > index));
          const template = remaining === 1 ? this._sticky.dataset.progressSingular : this._sticky.dataset.progressPlural;
          this._sticky.querySelector('.okb-sticky__copy').textContent = unlocked ? this._sticky.dataset.successCopy : (template || progress.textContent).split('{remaining}').join(String(remaining));
          this._stickySchedule();
        }
        const accessibleProgress = this.querySelector('[data-discount-progress]');
        accessibleProgress.setAttribute('aria-valuenow', String(Math.min(count, 3)));
        accessibleProgress.setAttribute('aria-label', 'Routine savings progress');
        accessibleProgress.setAttribute('aria-valuetext', count + ' items in your cart. ' + (unlocked ? this.querySelector('[data-reward-copy]').textContent : progress.textContent));
        this.dots.forEach((dot, index) => dot.classList.toggle('is-filled', count > index));
        const cartIds = new Set(items.map(item => String(item.product_id)));
        let covered = 0;
        this.steps.forEach(step => {
          const inCart = Array.from(this.productIdsFor(step)).some(id => cartIds.has(id));
          const previouslyCovered = step.classList.contains('is-covered');
          step.classList.toggle('is-covered', inCart);
          step.querySelector('[data-step-state]').textContent = inCart ? 'In your cart' : 'Not in your cart';
          if (inCart) covered++;
          if (animate && inCart && !previouslyCovered && !this._motion.matches) {
            this.play(step.querySelector('.okb__routine-node'), [{ transform: 'scale(.7)' }, { transform: 'scale(1.1)', offset: .65 }, { transform: 'scale(1)' }], { duration: 400 });
          }
        });
        this.querySelector('[data-coverage-count]').textContent = covered + ' of ' + this.steps.length + ' steps covered';
        if (!animate || wasUnlocked !== unlocked) this.cancelAnimations();
        if (animate && previousCount !== undefined && unlocked && !wasUnlocked && !this._motion.matches) {
          this.celebrate();
          if (stickyStart) this.celebrateSticky(stickyStart);
        }
        else if (animate && changed && !unlocked && count > previousCount && !this._motion.matches) {
          const dot = this.dots[Math.min(count, 3) - 1];
          this.play(dot, [{ scale: '.65' }, { scale: '1.12', offset: .65 }, { scale: '1' }], { duration: 400 });
        }
        if (animate && changed) {
          this.querySelector('[data-announcement]').textContent = unlocked ? count + ' items in your cart. ' + this.querySelector('[data-reward-copy]').textContent + ' Applied automatically at checkout.' : count + ' items in your cart. ' + progress.textContent;
        } else if (!animate) this.querySelector('[data-announcement]').textContent = '';
      }
      play(element, frames, timing) {
        if (!element?.animate) return;
        const animation = element.animate(frames, { easing: 'cubic-bezier(.22,1,.36,1)', ...timing });
        this._animations.add(animation);
        animation.onfinish = () => this._animations.delete(animation);
        return animation;
      }
      captureSticky() {
        const bar = this._sticky.getBoundingClientRect();
        return { bar, cartLeft: this._sticky.querySelector('.okb-sticky__cart').getBoundingClientRect().left, nodes: [...this._sticky.querySelectorAll('.okb-sticky__dots > .okb-sticky__dot'), this._sticky.querySelector('.okb-sticky__copy')].map(node => ({ clone: node.cloneNode(true), rect: node.getBoundingClientRect() })) };
      }
      celebrateSticky(start) {
        const bar = this._sticky;
        const duration = 3400;
        const bounds = bar.getBoundingClientRect();
        const badge = bar.querySelector('.okb-sticky__success');
        const copy = bar.querySelector('.okb-sticky__copy');
        const gap = parseFloat(getComputedStyle(bar).columnGap) || 10;
        const center = (start.nodes[0].rect.left + start.cartLeft - gap) / 2;
        const badgeBounds = badge.getBoundingClientRect();
        const shift = center - (badgeBounds.left + badgeBounds.width / 2);
        const ghost = document.createElement('div');
        ghost.setAttribute('aria-hidden', 'true');
        ghost.style.cssText = 'position:absolute;inset:0;pointer-events:none;overflow:hidden';
        bar.appendChild(ghost);
        this._stickyGhost = ghost;
        start.nodes.forEach(({ clone, rect }, index) => {
          if (index < 3) clone.classList.add('is-filled');
          // Stay hidden after the merge animation ends, until the full reveal removes the overlay.
          clone.style.cssText = `position:absolute;left:${rect.left - bounds.left}px;top:${rect.top - start.bar.top}px;width:${rect.width}px;height:${rect.height}px;margin:0;max-width:none;opacity:0;display:${index < 3 ? 'grid' : 'block'}`;
          ghost.appendChild(clone);
          this.play(clone, [
            { transform: 'translateX(0) scale(1)', opacity: 1 },
            { transform: `translateX(${center - rect.left - rect.width / 2}px) scale(${index < 3 ? 1 : .8})`, opacity: index < 3 ? 1 : 0, offset: .8 },
            { transform: `translateX(${center - rect.left - rect.width / 2}px) scale(${index < 3 ? 1 : .8})`, opacity: 0 }
          ], { duration: 900 });
        });
        this.play(badge, [
          { transform: `translateX(${shift}px) scale(.85)`, opacity: 0 },
          { transform: `translateX(${shift}px) scale(.85)`, opacity: 0, offset: .2 },
          { transform: `translateX(${shift}px) scale(1)`, opacity: 1, offset: .28 },
          { transform: `translateX(${shift}px) scale(1)`, opacity: 1, offset: .6 },
          { transform: 'translateX(0) scale(1)', opacity: 1 }
        ], { duration });
        this.celebrateSurface(bar, [badge]);
        const finish = this.play(copy, [
          { opacity: 0, transform: 'translateX(8px)' },
          { opacity: 0, transform: 'translateX(8px)', offset: .73 },
          { opacity: 1, transform: 'translateX(0)' }
        ], { duration });
        finish?.finished.catch(() => {}).finally(() => { ghost.remove(); if (this._stickyGhost === ghost) this._stickyGhost = null; });
      }
      celebrateSurface(surface, badges) {
        const successBackground = '#7d9557';
        // Give the color its own clock without slowing the checkmark or message.
        const colorDuration = 3900;
        const colorEase = 'cubic-bezier(.22,1,.36,1)';
        const celebrateColors = (element, resting, success) => this.play(element, [
          { ...resting },
          { ...resting, offset: 400 / colorDuration, easing: colorEase },
          { ...success, offset: 1000 / colorDuration },
          { ...success, offset: 2900 / colorDuration, easing: colorEase },
          { ...resting }
        ], { duration: colorDuration, easing: 'linear' });
        const surfaceStyle = getComputedStyle(surface);
        celebrateColors(surface,
          { backgroundColor: surfaceStyle.backgroundColor, color: surfaceStyle.color },
          { backgroundColor: successBackground, color: '#ffffff' });
        badges.forEach(badge => {
          const style = getComputedStyle(badge);
          celebrateColors(badge,
            { backgroundColor: style.backgroundColor, color: style.color, borderColor: style.borderColor },
            { backgroundColor: '#ffffff', color: successBackground, borderColor: '#ffffff' });
        });
      }
      celebrate() {
        this.celebrateSurface(this,
          [...this.querySelectorAll('[data-reward-badge], .okb__dot.is-filled, .okb__routine-step.is-covered .okb__routine-node')]);
        const dots = this.querySelector('[data-dots]');
        this.play(dots, [{ opacity: 1 }, { opacity: 1, offset: .8 }, { opacity: 0 }], { duration: 720 });
        this.dots.forEach(dot => {
          this.play(dot, [{ transform: getComputedStyle(dot).transform }, { transform: 'translate(-50%, -50%)' }], { duration: 650 });
        });
        const row = this.querySelector('[data-reward-row]');
        const badge = this.querySelector('[data-reward-badge]');
        const start = Math.max(0, (row.getBoundingClientRect().width - badge.getBoundingClientRect().width) / 2);
        this.play(badge, [
          { transform: 'translateX(' + start + 'px) scale(.65)', opacity: 0 },
          { transform: 'translateX(' + start + 'px) scale(.65)', opacity: 0, offset: .35 },
          { transform: 'translateX(' + start + 'px) scale(1.08)', opacity: 1, offset: .5 },
          { transform: 'translateX(' + start + 'px) scale(1)', opacity: 1, offset: .6 },
          { transform: 'translateX(0) scale(1)', opacity: 1 }
        ], { duration: 1600 });
        this.play(this.querySelector('[data-reward-copy]'), [{ opacity: 0, transform: 'translateX(8px)' }, { opacity: 0, transform: 'translateX(8px)', offset: .65 }, { opacity: 1, transform: 'translateX(0)' }], { duration: 1600 });
      }
      cancelAnimations() {
        this._stickyGhost?.remove();
        this._stickyGhost = null;
        this._animations?.forEach(animation => animation.cancel());
        this._animations?.clear();
      }
      disconnectedCallback() {
        window.removeEventListener('cart-notification:show', this._stickyNotification, true);
        window.removeEventListener('scroll', this._stickySchedule);
        window.removeEventListener('resize', this._stickySchedule);
        document.removeEventListener('transitionend', this._stickySchedule);
        document.removeEventListener('focusin', this._stickySchedule);
        cancelAnimationFrame(this._stickyFrame);
        this._stickyFrame = 0;
        this._stickyResize?.disconnect();
        this._stickyOverlay?.disconnect();
        this._sticky?.remove();
        this._initialized = false;
        ++this._revision;
        this.cancelAnimations();
        document.removeEventListener('DOMContentLoaded', this._ready);
        document.documentElement.removeEventListener('cart:updated', this._onCart);
        document.documentElement.removeEventListener('cart:refresh', this._onCart);
        document.removeEventListener('shopify:section:load', this._editorChange);
        document.removeEventListener('shopify:section:unload', this._editorChange);
        document.removeEventListener('visibilitychange', this._resume);
        window.removeEventListener('focus', this._resume);
        window.removeEventListener('pageshow', this._resume);
        window.removeEventListener('resize', this._layoutChange);
        this._motion?.removeEventListener?.('change', this._layoutChange);
        this.removeEventListener('click', this._retry);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onekind-routine-steps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('onekind-routine-steps')) {
    customElements.define('onekind-routine-steps', class extends HTMLElement {
      connectedCallback() {
        // The element can connect before its children finish parsing.
        if (document.readyState === 'loading') {
          this._ready = () => this.initialize();
          document.addEventListener('DOMContentLoaded', this._ready, { once: true });
        } else {
          this.initialize();
        }
      }
      initialize() {
        if (this._initialized || !this.isConnected) return;
        this._initialized = true;
        this._addedItems = this._addedItems || new Map();
        this._removeUncertain = this._removeUncertain || new Set();
        this._cartProductIds = this._cartProductIds || new Set((this.dataset.cartProductIds || '').split(',').filter(Boolean));
        this._cartRevision = this._cartRevision || 0;
        this._stepAnimations = new Map();
        this._motion = matchMedia('(prefers-reduced-motion: reduce)');
        this._reduceMotion = () => {
          if (!this._motion.matches) return;
          this._stepAnimations.forEach((animation, marker) => {
            animation.cancel();
            marker.hidden = marker.dataset.cartPresent !== 'true';
          });
          this._stepAnimations.clear();
        };
        this._motion.addEventListener?.('change', this._reduceMotion);
        this._cartHasSynced = false;
        this.steps = Array.from(this.querySelectorAll('[data-step]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.mode = this.dataset.defaultMode === 'pm' ? 'pm' : 'am';
        this._click = (event) => {
          const step = event.target.closest('[data-step]');
          const mode = event.target.closest('[data-mode]');
          const undo = event.target.closest('[data-cart-undo]');
          const remove = event.target.closest('[data-cart-remove]');
          if (undo && this.contains(undo)) this.undoAdd(undo.closest('form'));
          if (remove && this.contains(remove)) this.removeExisting(remove.closest('.oks__cart-form, [data-existing-cart]'));
          if (step && this.contains(step)) this.select(step.dataset.step, true);
          if (mode && this.contains(mode)) this.setMode(mode.dataset.mode, true);
        };
        this._blockSelect = (event) => {
          const step = this.steps.find((item) => item.dataset.step === event.detail.blockId);
          if (!step) return;
          if (step.dataset.timing !== 'both' && step.dataset.timing !== this.mode) this.setMode(step.dataset.timing, false);
          this.select(step.dataset.step, false);
        };
        this.addEventListener('click', this._click);
        this.addEventListener('shopify:block:select', this._blockSelect);
        this._submit = (event) => {
          const form = event.target.closest('.oks__cart-form');
          if (!form || !this.contains(form)) return;
          event.preventDefault();
          this.addToCart(form);
        };
        this.addEventListener('submit', this._submit);
        this._cartEvent = (event) => {
          if (Array.isArray(event.detail?.cart?.items)) this.applyCart(event.detail.cart);
          else this.syncCart();
        };
        this._resumeCart = () => { if (!document.hidden) this.syncCart(); };
        document.documentElement.addEventListener('cart:updated', this._cartEvent);
        document.documentElement.addEventListener('cart:refresh', this._cartEvent);
        window.addEventListener('pageshow', this._resumeCart);
        window.addEventListener('focus', this._resumeCart);
        document.addEventListener('visibilitychange', this._resumeCart);
        this.querySelectorAll('[data-controls]').forEach((control) => { control.hidden = false; });
        this.setMode(this.mode, false);
        this.renderCartStates();
        this.renderStepCart(false);
        this.syncCart();
        this.loadLargeCollections();
      }
      async loadLargeCollections() {
        // Small step collections are fully seeded by Liquid; only larger catalogs need extra pages.
        for (const step of this.steps) {
          if (!step.dataset.collectionUrl || Number(step.dataset.collectionCount) <= 250) continue;
          try {
            const ids = new Set((step.dataset.collectionProductIds || '').split(',').filter(Boolean));
            for (let page = 1; page <= Math.ceil(Number(step.dataset.collectionCount) / 250); page++) {
              if (!this.isConnected) return;
              const response = await fetch(step.dataset.collectionUrl + '/products.json?limit=250&page=' + page, { headers: { Accept: 'application/json' } });
              if (!response.ok) throw new Error('Collection unavailable');
              const result = await response.json();
              if (!Array.isArray(result.products)) throw new Error('Collection unavailable');
              result.products.forEach(product => ids.add(String(product.id)));
            }
            if (!this.isConnected) return;
            step.dataset.collectionProductIds = [...ids].join(',');
            this.renderStepCart(false);
          } catch (_) {
            // Preserve confirmed membership and cart state if a collection cannot be refreshed.
          }
        }
      }
      syncCart() {
        if (!this.dataset.cartUrl || !this.isConnected) return;
        const revision = ++this._cartRevision;
        this._cartRead = (async () => {
          try {
            const response = await fetch(this.dataset.cartUrl + '.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
            if (!response.ok) return;
            const cart = await response.json();
            if (this._initialized && this.isConnected && revision === this._cartRevision) this.applyCart(cart, Boolean(this._cartHasSynced));
          } catch (error) {
            // Keep the last confirmed state when offline; do not invent cart contents.
          }
        })();
        return this._cartRead;
      }
      applyCart(cart, animate = true) {
        if (!Array.isArray(cart?.items)) return;
        this._cartHasSynced = true;
        ++this._cartRevision;
        const items = cart.items.filter(item => item.quantity > 0);
        this._cartProductIds = new Set(items.map(item => String(item.product_id)));
        this._removeUncertain.forEach(id => { if (!this._cartProductIds.has(id)) this._removeUncertain.delete(id); });
        // If another cart control removes an item, allow it to be added again here.
        this._addedItems.forEach((state, variantId) => {
          if (items.some(item => this.lineSignature(item) === state.signature)) return;
          this._addedItems.delete(variantId);
          this.querySelectorAll('.oks__cart-form').forEach((form) => {
            if (form.elements.id.value !== variantId) return;
            form.querySelector('[data-cart-actions]').hidden = true;
            form.querySelector('[data-cart-message]').hidden = true;
          });
        });
        this.renderCartStates();
        this.renderStepCart(animate);
      }
      renderStepCart(animate = true) {
        let anyInCart = false;
        this.steps.forEach((step) => {
          const panel = this.panels.find(panel => panel.dataset.panel === step.dataset.step);
          // Collection members count alongside the morning and evening suggestions.
          const collectionIds = (step.dataset.collectionProductIds || '').split(',').filter(Boolean);
          const inCart = collectionIds.some(id => this._cartProductIds.has(id)) || Boolean(panel && Array.from(panel.querySelectorAll('[data-product-id]')).some(product => this._cartProductIds.has(product.dataset.productId)));
          anyInCart = anyInCart || inCart;
          this.animateStepCart(step.querySelector('[data-step-cart]'), inCart, animate);
          step.setAttribute('aria-label', step.dataset.stepLabel + (inCart ? ', product from this step in cart' : ''));
          step.title = inCart ? 'Product from this step in cart' : '';
        });
        this.querySelector('[data-cart-legend]').hidden = !anyInCart;
      }
      animateStepCart(marker, inCart, animate) {
        const next = String(inCart);
        const previous = marker.dataset.cartPresent;
        if (previous === next && animate) return;
        marker.dataset.cartPresent = next;
        this._stepAnimations.get(marker)?.cancel();
        this._stepAnimations.delete(marker);
        // Existing cart contents appear quietly; only subsequent changes pop.
        if (!animate || previous === undefined || !marker.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          marker.hidden = !inCart;
          return;
        }
        marker.hidden = false;
        const frames = inCart ? [
          { transform: 'scale(.25)', opacity: 0 },
          { transform: 'scale(1.18)', opacity: 1, offset: .6 },
          { transform: 'scale(.95)', opacity: 1, offset: .82 },
          { transform: 'scale(1)', opacity: 1 }
        ] : [
          { transform: 'scale(1)', opacity: 1 },
          { transform: 'scale(1.12)', opacity: 1, offset: .3 },
          { transform: 'scale(.2)', opacity: 0 }
        ];
        const animation = marker.animate(frames, { duration: inCart ? 480 : 300, easing: 'cubic-bezier(.22,1,.36,1)' });
        this._stepAnimations.set(marker, animation);
        animation.onfinish = () => {
          if (this._stepAnimations.get(marker) !== animation) return;
          marker.hidden = marker.dataset.cartPresent !== 'true';
          this._stepAnimations.delete(marker);
        };
      }
      async addToCart(form) {
        // One pending addition per guide prevents double-clicks and AM/PM races.
        const variantId = form.elements.id.value;
        if (this._cartPending || this._addedItems.has(variantId) || this._cartProductIds.has(form.closest('[data-product-id]').dataset.productId)) return;
        this._cartPending = true;
        const button = form.querySelector('button[type="submit"]');
        const hadFocus = document.activeElement === button;
        const message = form.querySelector('[data-cart-message]');
        this.renderCartStates();
        button.setAttribute('aria-busy', 'true');
        button.querySelector('[data-button-label]').textContent = 'Adding…';
        message.hidden = true;
        message.classList.remove('is-success');
        message.textContent = '';
        form.querySelector('[data-cart-actions]').hidden = true;
        let added = false;
        try {
          const payload = new FormData(form);
          payload.delete('return_to');
          payload.set('sections', 'mini-cart');
          payload.set('sections_url', window.location.pathname);
          const response = await fetch(form.getAttribute('action') + '.js', {
            method: 'POST', body: payload,
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
          });
          // Treat an unreadable response as uncertain; never retry the POST automatically.
          const result = await response.json();
          if (!response.ok) {
            message.textContent = typeof result.description === 'string' ? result.description : 'This item could not be added. Please check its availability.';
            message.hidden = false;
            return;
          }
          added = true;
          const item = result.items ? result.items[0] : result;
          ++this._cartRevision;
          this._cartProductIds.add(String(item.product_id || form.closest('[data-product-id]').dataset.productId));
          this.renderStepCart();
          this._addedItems.set(variantId, { key: item.key, signature: this.lineSignature(item), quantity: Number(payload.get('quantity')) || 1 });
          this.renderCartStates();
          message.textContent = 'Added to cart.';
          message.classList.add('is-success');
          message.hidden = false;
          form.dispatchEvent(new CustomEvent('variant:added', {
            bubbles: true, detail: { variant: item }
          }));
          // Use the same theme-owned green confirmation as collection quick-add.
          form.dispatchEvent(new CustomEvent('cart-notification:show', {
            bubbles: true, cancelable: true, detail: { status: 'success', error: '' }
          }));
          const cartResponse = await fetch(form.dataset.cartUrl + '.js', {
            headers: { 'Accept': 'application/json' }, cache: 'no-store'
          });
          if (!cartResponse.ok) throw new Error('Cart refresh unavailable');
          const cart = await cartResponse.json();
          this.refreshCart(cart, result.sections);
        } catch (error) {
          if (added) {
            // The add succeeded: a refresh problem must not invite a duplicate add.
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true, detail: { openMiniCart: false }
            }));
            message.textContent = 'Added to cart, but the cart display could not refresh. Use View cart below to check it.';
          } else {
            message.textContent = 'We could not confirm the addition. Please check your cart before trying again.';
          }
          message.classList.remove('is-success');
          message.hidden = false;
          form.querySelector('[data-cart-actions]').hidden = false;
        } finally {
          button.removeAttribute('aria-busy');
          button.querySelector('[data-button-label]').textContent = 'Add to cart';
          this._cartPending = false;
          this.renderCartStates();
          this.querySelector('[data-cart-announcement]').textContent = message.textContent;
          if (hadFocus && (document.activeElement === button || document.activeElement === document.body)) {
            const target = added ? form.querySelector('[data-cart-link]') : button;
            target?.focus({ preventScroll: true });
          }
        }
      }
      lineSignature(item) {
        return JSON.stringify([
          String(item.variant_id || item.id),
          Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b)),
          item.selling_plan_allocation?.selling_plan?.id || null
        ]);
      }
      renderCartStates() {
        this.querySelectorAll('.oks__cart-form').forEach((form) => {
          const state = this._addedItems.get(form.elements.id.value);
          const button = form.querySelector('button[type="submit"]');
          const undo = form.querySelector('[data-cart-undo]');
          const inCart = Boolean(state || this._cartProductIds.has(form.closest('[data-product-id]').dataset.productId));
          const wasInCart = button.classList.contains('is-added');
          button.classList.toggle('is-added', inCart);
          button.classList.toggle('is-existing', inCart && !state);
          button.disabled = Boolean(inCart || this._cartPending);
          const successLabel = state ? 'Added to Cart' : 'Already in cart';
          button.querySelector('.oks__cart-success > span').textContent = successLabel;
          button.setAttribute('aria-label', inCart ? (state ? 'Added to cart' : 'Already in cart') : button.dataset.addLabel);
          undo.hidden = !state;
          undo.disabled = Boolean(this._cartPending || state?.uncertain);
          form.querySelector('[data-cart-remove]').hidden = !inCart || Boolean(state);
          if (inCart) form.querySelector('[data-cart-actions]').hidden = false;
          else if (wasInCart) {
            form.querySelector('[data-cart-actions]').hidden = true;
            form.querySelector('[data-cart-message]').hidden = true;
          }
        });
        this.querySelectorAll('[data-existing-cart]').forEach((existing) => {
          const product = existing.closest('[data-product-id]');
          const inCart = this._cartProductIds.has(product.dataset.productId);
          existing.hidden = !inCart;
          product.querySelector('[data-cart-choice]').hidden = inCart;
        });
        this.querySelectorAll('[data-cart-remove]').forEach((remove) => {
          remove.disabled = Boolean(this._cartPending || this._removeUncertain.has(remove.closest('[data-product-id]').dataset.productId));
        });
      }
      async removeExisting(container) {
        const product = container.closest('[data-product-id]');
        const productId = product.dataset.productId;
        const variantId = container.matches('form') ? container.elements.id.value : null;
        if (this._cartPending || this._removeUncertain.has(productId) || !this._cartProductIds.has(productId) || (variantId && this._addedItems.has(variantId))) return;
        const remove = container.querySelector('[data-cart-remove]');
        const returnFocus = document.activeElement === remove;
        const message = container.querySelector('[data-cart-message]');
        this._cartPending = true;
        this.renderCartStates();
        remove.textContent = 'Removing…';
        remove.setAttribute('aria-busy', 'true');
        message.hidden = true;
        message.classList.remove('is-success');
        let changeSent = false;
        let removed = false;
        try {
          const response = await fetch(this.dataset.cartUrl + '.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
          if (!response.ok) throw new Error('Cart unavailable');
          let cart = await response.json();
          const matches = cart.items.filter(item => String(item.product_id) === productId && item.quantity > 0);
          // Do not guess between different variants, subscriptions, or personalized lines.
          if (matches.length > 1) {
            message.textContent = 'This product has multiple cart entries. Use View cart to choose which to remove.';
            message.hidden = false;
            return;
          }
          if (matches.length === 1) {
            changeSent = true;
            const changed = await fetch(this.dataset.cartUrl + '/change.js', {
              method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: matches[0].key, quantity: 0, sections: ['mini-cart'], sections_url: window.location.pathname })
            });
            if (!changed.ok) {
              if (changed.status >= 400 && changed.status < 500) changeSent = false;
              throw new Error('Removal rejected');
            }
            cart = await changed.json();
          }
          this.refreshCart(cart, cart.sections);
          removed = true;
          message.textContent = matches.length ? 'Removed from your cart.' : 'This item is already out of your cart.';
          message.hidden = false;
        } catch (error) {
          if (changeSent) this._removeUncertain.add(productId);
          message.textContent = changeSent ? 'We could not confirm the removal. Please view your cart to check it.' : 'We could not remove this item. Please try again or view your cart.';
          message.hidden = false;
        } finally {
          this._cartPending = false;
          remove.textContent = 'Remove';
          remove.removeAttribute('aria-busy');
          this.renderCartStates();
          this.querySelector('[data-cart-announcement]').textContent = message.textContent;
          if (returnFocus && removed) {
            const target = product.querySelector('button[type="submit"]:not(:disabled), a[data-cart-choice]') || product.querySelector('.oks__product-title');
            target?.focus({ preventScroll: true });
          }
        }
      }
      refreshCart(cart, sections) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
        const markup = sections && sections['mini-cart'];
        // A null section should make the theme fetch its own fresh HTML.
        delete cart.sections;
        if (typeof markup === 'string' && new DOMParser().parseFromString(markup, 'text/html').querySelector('cart-drawer')) {
          cart.sections = { 'mini-cart': markup };
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart, openMiniCart: false } }));
      }
      async undoAdd(form) {
        const variantId = form.elements.id.value;
        const state = this._addedItems.get(variantId);
        if (this._cartPending || !state || state.uncertain) return;
        const undo = form.querySelector('[data-cart-undo]');
        const returnFocus = document.activeElement === undo;
        this._cartPending = true;
        this.renderCartStates();
        const message = form.querySelector('[data-cart-message]');
        undo.textContent = 'Undoing…';
        undo.setAttribute('aria-busy', 'true');
        message.hidden = true;
        message.classList.remove('is-success');
        let changeSent = false;
        try {
          // Read the current quantity, not the quantity from the original add.
          const response = await fetch(form.dataset.cartUrl + '.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
          if (!response.ok) throw new Error('Cart unavailable');
          let cart = await response.json();
          const matches = cart.items.filter(item => this.lineSignature(item) === state.signature);
          const item = matches.find(item => item.key === state.key) || (matches.length === 1 ? matches[0] : null);
          if (!item && matches.length) throw new Error('Ambiguous cart lines');
          if (item) {
            // Line keys can change after discounts. Never remove a whole variant blindly.
            changeSent = true;
            const changed = await fetch(form.dataset.cartUrl + '/change.js', {
              method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: Math.max(0, item.quantity - state.quantity), sections: ['mini-cart'], sections_url: window.location.pathname })
            });
            if (!changed.ok) {
              if (changed.status >= 400 && changed.status < 500) changeSent = false;
              throw new Error('Change rejected');
            }
            cart = await changed.json();
          }
          this._addedItems.delete(variantId);
          this.querySelectorAll('.oks__cart-form').forEach((related) => {
            if (related.elements.id.value !== variantId) return;
            related.querySelector('[data-cart-actions]').hidden = true;
            related.querySelector('[data-cart-message]').hidden = true;
          });
          this.refreshCart(cart, cart.sections);
          message.textContent = item ? 'Undone. Your previous cart items are unchanged.' : 'This item is already out of your cart.';
          message.hidden = false;
          // Return keyboard focus when the Undo control disappears.
          if (returnFocus) {
            const inCart = this._cartProductIds.has(form.closest('[data-product-id]').dataset.productId);
            const target = form.querySelector(inCart ? '[data-cart-link]' : 'button[type="submit"]');
            if (!inCart) target.disabled = false;
            target.focus({ preventScroll: true });
          }
        } catch (error) {
          // An uncertain write must never be retried: that could remove another unit.
          if (changeSent) state.uncertain = true;
          message.textContent = changeSent ? 'We could not confirm Undo. Please view your cart to check it.' : 'We could not safely undo this addition. Please try again or view your cart.';
          message.hidden = false;
        } finally {
          this._cartPending = false;
          undo.textContent = 'Undo';
          undo.removeAttribute('aria-busy');
          this.renderCartStates();
          this.querySelector('[data-cart-announcement]').textContent = message.textContent;
        }
      }
      setMode(mode, announce) {
        this.mode = mode;
        this.querySelectorAll('[data-mode]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.mode === mode)));
        this.steps.forEach((step) => { step.hidden = step.dataset.timing !== 'both' && step.dataset.timing !== mode; });
        this.querySelectorAll('[data-products]').forEach((group) => { group.hidden = group.dataset.products !== mode; });
        // Collapse an empty product column for the selected time of day.
        this.panels.forEach((panel) => {
          const recommendations = panel.querySelector('.oks__recommendations');
          if (!recommendations) return;
          const group = recommendations.querySelector('[data-products="' + mode + '"]');
          const hasProducts = Boolean(group && group.querySelector('.oks__product'));
          recommendations.hidden = !hasProducts;
          panel.querySelector('.oks__panel-grid').classList.toggle('oks__panel-grid--text-only', !hasProducts);
        });
        const active = this.steps.find((step) => step.dataset.step === this.active && !step.hidden);
        const next = active || this.steps.find((step) => !step.hidden);
        this.select(next ? next.dataset.step : null, announce);
      }
      select(id, announce) {
        this.active = id;
        this.steps.forEach((step) => step.setAttribute('aria-pressed', String(step.dataset.step === id)));
        this.panels.forEach((panel) => { panel.hidden = panel.dataset.panel !== id; });
        this.querySelector('[data-empty]').hidden = Boolean(id);
        const selected = this.steps.find((step) => step.dataset.step === id);
        const status = this.querySelector('[data-status]');
        status.textContent = announce ? (selected ? (this.mode === 'am' ? 'Morning: ' : 'Evening: ') + selected.textContent.trim().replace(/\s+/g, ' ') : 'No steps for this time of day.') : '';
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this._ready);
        this.removeEventListener('click', this._click);
        this.removeEventListener('shopify:block:select', this._blockSelect);
        this.removeEventListener('submit', this._submit);
        document.documentElement.removeEventListener('cart:updated', this._cartEvent);
        document.documentElement.removeEventListener('cart:refresh', this._cartEvent);
        window.removeEventListener('pageshow', this._resumeCart);
        window.removeEventListener('focus', this._resumeCart);
        document.removeEventListener('visibilitychange', this._resumeCart);
        this._stepAnimations?.forEach((animation, marker) => {
          animation.cancel();
          marker.hidden = marker.dataset.cartPresent !== 'true';
        });
        this._stepAnimations?.clear();
        this._motion?.removeEventListener?.('change', this._reduceMotion);
        ++this._cartRevision;
        this._initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
